export const SCREEN_STATE_ACTION = 'action';
export const SCREEN_STATE_VIEW = 'view';
